import Vue from 'vue'
import Vuex from 'vuex'
import * as ACTIONS from '../actions'
import * as MUTATIONS from '../mutations'
import API from '../../services/api'

Vue.use(Vuex)

export default {
	state: {
		interaction: {
			interactions: {
				name: 'Interactions',
				description: 'Interacciones por dia',
				data: [],
			},
			likes: {
				name: 'Likes',
				description: 'Likes por dia',
				data: [],
			},
			views: {
				name: 'Views',
				description: 'Views por dia',
				data: [],
			},
			comments: {
				name: 'Comments',
				description: 'Comments por dia',
				data: [],
			},
			dates: [],
		},
		follower: {
			total: {
				accounts: [],
				value: {
					name: 'Total Followers',
					data: [],
				},
			},
			growth: {
				accounts: [],
				value: {
					name: 'Followers Growth',
					data: [],
				},
				percentage: {
					name: 'Followers Growth Percentage',
					data: [],
				},
			},
		},
		share: [],
		topinfluencerinteractions: {
			data: [],
			stats: {
				other: [],
				salonline: [],
				todecacho: [],
			},
		},
		topinfluencerengagement: {
			data: [],
			stats: {
				other: [],
				salonline: [],
				todecacho: [],
			},
		},
		topbusinessinteractions: {
			data: [],
			stats: {
				other: [],
				salonline: [],
				todecacho: [],
			},
		},
		topbusinessengagement: {
			data: [],
			stats: {
				other: [],
				salonline: [],
				todecacho: [],
			},
		},
		stats: {
			accounts: [],
			likes: {
				name: 'Likes',
				type: 'column',
				data: [],
			},
			posts: {
				name: 'Posts',
				type: 'line',
				data: [],
			},
			comments: {
				name: 'Comments',
				type: 'column',
				data: [],
			},
		},
		accounts: {
			data: [],
		},
	},
	mutations: {
		/*
		[MUTATIONS.DASHBOARD.INTERACTIONS](state, result) {
			state.interaction.dates = []
			state.interaction.interactions.data = []
			state.interaction.likes.data = []
			state.interaction.views.data = []
			state.interaction.comments.data = []

			for (let index = 0; index < result.length; index++) {
				const data = result[index]
				state.interaction.dates.push(data.created)
				state.interaction.interactions.data.push(data.interactions)
				state.interaction.likes.data.push(data.likes)
				state.interaction.views.data.push(data.views)
				state.interaction.comments.data.push(data.comments)
			}
		},
		*/
		[MUTATIONS.DASHBOARD.FOLLOWERS](state, result) {
			// TODO DO: quick fix, when reload the page chart duplicate results
			state.follower.total.accounts = []
			state.follower.growth.accounts = []
			state.follower.total.value.data = []
			state.follower.growth.value.data = []
			state.follower.growth.percentage.data = []

			for (let index = 0; index < result.length; index++) {
				const data = result[index]
				state.follower.total.accounts.push(data.accountName)
				state.follower.growth.accounts.push(data.accountName)
				state.follower.total.value.data.push(data.total)
				state.follower.growth.value.data.push(data.growth)
				state.follower.growth.percentage.data.push(data.percentage)
			}
		},

		/* [MUTATIONS.DASHBOARD.STATS](state, result) {
			// TODO DO: quick fix, when reload the page chart duplicate results
			state.stats.accounts = []
			state.stats.likes.data = []
			state.stats.posts.data = []
			state.stats.comments.data = []
			for (let index = 0; index < result.length; index++) {
				const data = result[index]
				state.stats.accounts.push(data.accountName)
				state.stats.likes.data.push(data.likes)
				state.stats.posts.data.push(data.posts)
				state.stats.comments.data.push(data.comments)
			}
		}, */
	},
	actions: {
		[ACTIONS.DASHBOARD.ACCOUNTS]({ commit, dispatch, state }, filter = {}) {
			return API.DASHBOARD.ACCOUNTS(filter).then(res => {
				// commit(MUTATIONS.DASHBOARD.INTERACTIONS, res)
				state.accounts.data = res
				return res
			})
		},
		[ACTIONS.DASHBOARD.INTERACTIONS_ADMIN](
			{ commit, dispatch, state },
			filter = {},
		) {
			const interaction = API.DASHBOARD.INTERACTIONS_ADMIN(filter)
			const competitors = API.DASHBOARD.INTERACTIONS_COMPETITORS(filter)

			return Promise.all([interaction, competitors])
		},
		[ACTIONS.DASHBOARD.INTERACTIONS_USER](
			{ commit, dispatch, state },
			filter = {},
		) {
			return API.DASHBOARD.INTERACTIONS_USER(filter).then(res => {
				const interaction = API.DASHBOARD.INTERACTIONS_USER(filter)
				const competitors = API.DASHBOARD.INTERACTIONS_COMPETITORS_USER(filter)
				// commit(MUTATIONS.DASHBOARD.INTERACTIONS, res)
				return Promise.all([interaction, competitors])
			})
		},
		[ACTIONS.DASHBOARD.FOLLOWERS_USER](
			{ commit, dispatch, state },
			filter = {},
		) {
			return API.DASHBOARD.FOLLOWERS_USER(filter).then(res => {
				// commit(MUTATIONS.DASHBOARD.FOLLOWERS, res)
				return res
			})
		},
		[ACTIONS.DASHBOARD.FOLLOWERS_ADMIN](
			{ commit, dispatch, state },
			filter = {},
		) {
			return API.DASHBOARD.FOLLOWERS_ADMIN(filter).then(res => {
				// commit(MUTATIONS.DASHBOARD.FOLLOWERS, res)
				return res
			})
		},
		[ACTIONS.DASHBOARD.STATS]({ commit, dispatch, state }, filter = {}) {
			return API.DASHBOARD.STATS(filter).then(res => {
				// commit(MUTATIONS.DASHBOARD.STATS, res)
				return res
			})
		},
		[ACTIONS.DASHBOARD.STATS_USER]({ commit, dispatch, state }, filter = {}) {
			return API.DASHBOARD.STATS_USER(filter).then(res => {
				// commit(MUTATIONS.DASHBOARD.STATS_USER, res)
				return res
			})
		},
	},

	getters: {
		getDashboardInteractions: state => state.interaction,

		getDashboardInteractionsShare: state => state.share,
		//

		getDashboardTotalFollowers: state => state.follower.total,
		getDashboardFollowersGrowth: state => state.follower.growth,

		getDashboardAccounts: state => state.accounts.data,
	},
}
